import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
//Limitless imports
import { useDialogueBodyStyles } from "./DialogueBody";
import CustomerButton from "../customer-button/CustomerButton";
import ExpandIcon from "@limitless/icons/ExpandIcon";
import CollapseIcon from "@limitless/icons/CollapseIcon";
const useStyles = makeStyles({
  clamp: {
    display: "-webkit-box",
    lineClamp: 10,
    boxOrient: "vertical"
  },
  clampBody: {
    marginBottom: 24
  }
});
const ClampedDialogueBody = ({
  body,
  textStyling,
  index
}) => {
  const [clamped, setClamped] = React.useState(true);
  const [textHeight, setTextHeight] = React.useState(0);
  const textRef = React.useRef(null);
  const bodyClasses = useDialogueBodyStyles();
  const theme = useTheme();
  const classes = useStyles();
  React.useEffect(() => {
    setTextHeight(textRef.current.offsetHeight);
  }, [textRef]);
  let rootClass = textStyling;
  const shouldClamp = textHeight > 200 ? true : false;
  if (shouldClamp && clamped) {
    rootClass = `${textStyling} ${classes.clamp}`;
  }
  const onDialogueClick = React.useCallback(() => {
    setClamped(!clamped);
  });
  const ClampIcon = clamped ? ExpandIcon : CollapseIcon;
  return /*#__PURE__*/React.createElement(Typography, {
    ref: textRef,
    classes: {
      root: rootClass
    },
    component: "div",
    tabIndex: 0,
    variant: "body2",
    className: `${bodyClasses.dialogueBody} ${shouldClamp && classes.clampBody}`
  }, body, shouldClamp && /*#__PURE__*/React.createElement(CustomerButton, {
    id: `toggleDialogueSizeButton${index}`,
    variant: "text",
    onClick: onDialogueClick,
    style: {
      position: "absolute",
      left: 16,
      bottom: 6,
      padding: 0,
      minWidth: "unset"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body",
    sx: {
      color: theme.palette.primary.main
    }
  }, clamped ? "Countinue reading" : "See Less"), /*#__PURE__*/React.createElement(ClampIcon, {
    color: theme.palette.primary.main
  })));
};
export default ClampedDialogueBody;
ClampedDialogueBody.propTypes = {
  body: PropTypes.string.isRequired,
  textStyling: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};